export const config = {
    prod:{
        apiKey: "AIzaSyB37tLv7FCGpB1SsYO-F4ilpQuQI0EYIrc",
        authDomain: "financeiro-4fb89.firebaseapp.com",
        databaseURL: "https://financeiro-4fb89.firebaseio.com",
        projectId: "financeiro-4fb89",
        storageBucket: "financeiro-4fb89.appspot.com",
        messagingSenderId: "837416770531"
    },
    stage:{
        apiKey: "AIzaSyASpxiGot1wYv9eWNvxSZBF9rkpCqYtvno",
        authDomain: "financeiro-dev.firebaseapp.com",
        databaseURL: "https://financeiro-dev.firebaseio.com",
        projectId: "financeiro-dev",
        storageBucket: "financeiro-dev.appspot.com",
        messagingSenderId: "860969333083"
      }

};


// WEBPACK FOOTER //
// ./src/firebase/config.js